import { render, staticRenderFns } from "./PopProductBottomLine.vue?vue&type=template&id=6d7b0a06&scoped=true&lang=pug"
import script from "./PopProductBottomLine.vue?vue&type=script&lang=js"
export * from "./PopProductBottomLine.vue?vue&type=script&lang=js"
import style0 from "./PopProductBottomLine.vue?vue&type=style&index=0&id=6d7b0a06&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7b0a06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d7b0a06')) {
      api.createRecord('6d7b0a06', component.options)
    } else {
      api.reload('6d7b0a06', component.options)
    }
    module.hot.accept("./PopProductBottomLine.vue?vue&type=template&id=6d7b0a06&scoped=true&lang=pug", function () {
      api.rerender('6d7b0a06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/PopProductBottomLine.vue"
export default component.exports